import React from 'react';

import Box from '../Box/Box';
import name from './name';

type TTextFieldPrefix = {
  children?: React.ReactNode;
};

const TextFieldPrefix = (props: TTextFieldPrefix) => <Box {...props} as="span" name="prefix" parent={name} />;

export default TextFieldPrefix;
